import { render } from "./addOrEditDialog.vue?vue&type=template&id=d082c3da&ts=true"
import script from "./addOrEditDialog.vue?vue&type=script&lang=ts"
export * from "./addOrEditDialog.vue?vue&type=script&lang=ts"

import exportComponent from "F:\\工作\\project\\kaola\\kaola-project-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__